import { FC, ReactElement, useMemo } from 'react';
import { HintTooltip, useBreakpoint } from '@brg/ui';
import styled from 'styled-components';
import { tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { LayoutConst } from 'core';
import { IContentViewItem } from '../../../../hooks/api/useContentView';
import { buildAdLegalTooltipText } from './buildAdLegalTooltipText';

const AD_LEGAL_TOOLTIP_MAX_WIDTH_PX = 300;
const AD_LEGAL_TOOLTIP_HIDE_BREAKPOINT_PX = LayoutConst.screen.l;
const AD_LEGAL_TOOLTIP_TEXT_OFFSET_WIDE_PX = 355;
const AD_LEGAL_TOOLTIP_TEXT_OFFSET_MAC13_PX = 200;
const AD_LEGAL_TOOLTIP_Z = 10000;

const TooltipRoot = styled.span`
  position: relative;
  display: block;
  z-index: 0;

  .tooltip-parent-element,
  #tooltip-parent-element {
    z-index: ${AD_LEGAL_TOOLTIP_Z} !important;
  }
`;

const TooltipHost = styled.span`
  display: contents;
`;

type AdLegalHintTooltipProps = {
    adItem: IContentViewItem;
    children: ReactElement;
    onWhiteBg?: boolean;
    customStyle?: Record<string, unknown>;
};

export const AdLegalHintTooltip: FC<AdLegalHintTooltipProps> = ({
    adItem,
    children,
    onWhiteBg = true,
    customStyle = tooptipStylesWhite,
}) => {
    const text = buildAdLegalTooltipText(adItem);
    const hideTooltip = useBreakpoint(AD_LEGAL_TOOLTIP_HIDE_BREAKPOINT_PX);
    const isMac13OrBelow = useBreakpoint(LayoutConst.screen.mac13);
    const isAtMostL = useBreakpoint(LayoutConst.screen.l);
    const textOffset = isMac13OrBelow && !isAtMostL
        ? `${AD_LEGAL_TOOLTIP_TEXT_OFFSET_MAC13_PX}px`
        : `${AD_LEGAL_TOOLTIP_TEXT_OFFSET_WIDE_PX}px`;
    const tooltipStyle = useMemo(
        () => ({
            ...customStyle,
            maxWidth: `${AD_LEGAL_TOOLTIP_MAX_WIDTH_PX}px`,
            whiteSpace: 'pre-line',
            wordBreak: 'break-word',
            zIndex: AD_LEGAL_TOOLTIP_Z,
        }),
        [customStyle],
    );

    if (!text || hideTooltip) {
        return children;
    }

    return (
        <TooltipRoot>
            <HintTooltip
                text={text}
                noArrow
                onWhiteBg={onWhiteBg}
                positionY="top"
                z={AD_LEGAL_TOOLTIP_Z}
                textOffset={textOffset}
                offsetYText="80px"
                customStyle={tooltipStyle}
            >
                <TooltipHost>{children}</TooltipHost>
            </HintTooltip>
        </TooltipRoot>
    );
};
import { FC, ReactElement, useMemo } from 'react';
import { HintTooltip, useBreakpoint } from '@brg/ui';
import styled from 'styled-components';
import { tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { LayoutConst } from 'core';
import { IContentViewItem } from '../../../../hooks/api/useContentView';
import { buildAdLegalTooltipText } from './buildAdLegalTooltipText';

const AD_LEGAL_TOOLTIP_MAX_WIDTH_PX = 300;
const AD_LEGAL_TOOLTIP_HIDE_BREAKPOINT_PX = LayoutConst.screen.l;
const AD_LEGAL_TOOLTIP_TEXT_OFFSET_WIDE_PX = 355;
const AD_LEGAL_TOOLTIP_TEXT_OFFSET_MAC13_PX = 200;
const AD_LEGAL_TOOLTIP_Z = 10000;

const TooltipRoot = styled.span`
  position: relative;
  display: block;
  z-index: 0;

  .tooltip-parent-element,
  #tooltip-parent-element {
    z-index: ${AD_LEGAL_TOOLTIP_Z} !important;
  }
`;

const TooltipHost = styled.span`
  display: contents;
`;

type AdLegalHintTooltipProps = {
    adItem: IContentViewItem;
    children: ReactElement;
    onWhiteBg?: boolean;
    customStyle?: Record<string, unknown>;
};

export const AdLegalHintTooltip: FC<AdLegalHintTooltipProps> = ({
    adItem,
    children,
    onWhiteBg = true,
    customStyle = tooptipStylesWhite,
}) => {
    const text = buildAdLegalTooltipText(adItem);
    const hideTooltip = useBreakpoint(AD_LEGAL_TOOLTIP_HIDE_BREAKPOINT_PX);
    const isMac13OrBelow = useBreakpoint(LayoutConst.screen.mac13);
    const isAtMostL = useBreakpoint(LayoutConst.screen.l);
    const textOffset = isMac13OrBelow && !isAtMostL
        ? `${AD_LEGAL_TOOLTIP_TEXT_OFFSET_MAC13_PX}px`
        : `${AD_LEGAL_TOOLTIP_TEXT_OFFSET_WIDE_PX}px`;
    const tooltipStyle = useMemo(
        () => ({
            ...customStyle,
            maxWidth: `${AD_LEGAL_TOOLTIP_MAX_WIDTH_PX}px`,
            whiteSpace: 'pre-line',
            wordBreak: 'break-word',
            zIndex: AD_LEGAL_TOOLTIP_Z,
        }),
        [customStyle],
    );

    if (!text || hideTooltip) {
        return children;
    }

    return (
        <TooltipRoot>
            <HintTooltip
                text={text}
                noArrow
                onWhiteBg={onWhiteBg}
                positionY="top"
                z={AD_LEGAL_TOOLTIP_Z}
                textOffset={textOffset}
                offsetYText="80px"
                customStyle={tooltipStyle}
            >
                <TooltipHost>{children}</TooltipHost>
            </HintTooltip>
        </TooltipRoot>
    );
};
